import { getAmplitudeInstance } from '../amplitudeHelpers';
import ListItemType from '../enums/ListItemType';
import MapType from '../enums/MapType';

type logListItemAddedParams = {
  list_id: number;
  list_item_type: MapType;
  list_type: ListItemType;
  map_id: number;
  map_type: MapType;
};

/**
 * The user has added an item to a list. This is the result of clicking the bookmark icon and selecting a list.
 * @param params - Attributes to log with the amplitude event
 * @param params.list_id - The id of the newly created list.
 * @param params.list_item_type - The type of list item saved to a list.
 * @param params.list_type - The type of list selected
 * @param params.map_id - The id of the map being saved (could be trail/activity/etc)
 * @param params.map_type - The type of map saved to a list.
 */
const logListItemAdded = ({ list_id, list_item_type, list_type, map_id, map_type }: logListItemAddedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'list item added',
    { 'list id': list_id, 'list item type': list_item_type, 'list type': list_type, 'map id': map_id, 'map type': map_type },
    callback
  );
};

export default logListItemAdded;
